<template>
  <div class="facet my-[2vh] mx-0">
    <box-generic w-stretch>
      <template #header><slot :name="type + 'Label'" /></template>
      <template #default>
        <div class="facet-link-wrapper mt-[-1vh]">
          <router-link
            v-for="facetItem in items"
            :key="facetItem.key"
            :to="facetItem.route"
            class="facet-link"
          >
            <slot :name="type" :item="facetItem.item" />
          </router-link>
        </div>
      </template>
    </box-generic>
  </div>
</template>

<script>
import BoxGeneric from "../BoxGeneric.vue";

export default {
  name: "MediaArchiveFacet",
  components: {
    BoxGeneric,
  },
  props: {
    type: {
      type: String,
    },
    label: {
      type: String,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
